import React, {useEffect, useRef, useState} from 'react';
import './dropdown.scss';

// How to use:
// Define isOpen state in parent component and pass it with the
// toggle function, and dropdown items as children

const Dropdown = ({trigger, children, className, buttonClass, toggleClose, disabled, riskConsideration}) => {
  const dropdown = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef();
  const [loaded, setLoaded] = useState(false);

  const toggle = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
    if (!loaded) setLoaded(true);
  };

  const handleClickOutside = (e) => {
    if (
      dropdown.current &&
      !dropdown.current.contains(e.target) &&
      !triggerRef.current.contains(e.target)
    ) {
      toggle(e);
    }
  };

  useEffect(() => {
      isOpen
      ? document.addEventListener('mousedown', handleClickOutside, false)
      : document.removeEventListener('mousedown', handleClickOutside, false);
    // Clear eventListener
    return () => document.removeEventListener('mousedown', toggle, false);
  }, [isOpen]);

  return (
    <div className={className + ' position-relative'}>
      <button
        ref={triggerRef}
        onClick={(e) => toggle(e)}
        className={buttonClass}
      >
        {trigger}
      </button>
      <div ref={dropdown}
           className={'dropdown-common ' + (isOpen && 'show') + ' ' + riskConsideration}>
        {loaded && (
          <ul className={'text-left ' + (isOpen && 'show')}>{children}</ul>
        )}
      </div>
    </div>
  );
};

export default Dropdown;